module.exports = __webpack_public_path__ + "static/media/error-icon.0884d6f7.png";